import React from 'react'
import { KpiCard } from '@/components/layout/KpiCard'
import type { MrpPlanningSummary } from '../types/mrpTypes'
import { formatNumberVi } from '../utils/mrpFormatters'

export interface MrpKpiStripProps {
  summary: MrpPlanningSummary
}

export function MrpKpiStrip({ summary }: MrpKpiStripProps): React.ReactElement {
  const hasShortages = summary.shortage_count > 0
  const hasWarnings = summary.warning_count > 0

  return (
    <div className="mb-4 grid grid-cols-2 gap-3 lg:grid-cols-4">
      <KpiCard
        label="Tổng vật tư cân đối"
        value={formatNumberVi(summary.total_items)}
        hint="Số loại vật tư trong kỳ kế hoạch"
        tone="default"
      />
      <KpiCard
        label="Vật tư thiếu (Cần mua)"
        value={formatNumberVi(summary.shortage_count)}
        hint={
          hasShortages
            ? `Tổng lượng thiếu: ${formatNumberVi(summary.total_shortage_qty)}`
            : 'Đủ vật tư khả dụng'
        }
        tone={hasShortages ? 'danger' : 'success'}
      />
      <KpiCard
        label="PO đang về"
        value={formatNumberVi(summary.incoming_po_count)}
        hint="Đơn hàng mua mở (Approved / Sent / Partial)"
        tone="default"
      />
      <KpiCard
        label="Cảnh báo quy đổi & vật tư"
        value={formatNumberVi(summary.warning_count)}
        hint={hasWarnings ? 'Cần kiểm tra quy đổi hoặc gán mã' : 'Dữ liệu chuẩn xác'}
        tone={hasWarnings ? 'warning' : 'default'}
      />
    </div>
  )
}
